import styled from 'styled-components';

export const ProcessLivenessContainer = styled.div`
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
    border-radius: 32px;

    .spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .liveness-process-actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-height: 76px;
        position: absolute;
        right: 0;
        top: calc(50% - 125px);

        ${(props) => props.theme.breakpointTo.sm} {
            position: fixed;
            top: 16px;
            margin-right: 16px;
        }

        .take-photo-button {
            margin-top: 32px;

            ${(props) => props.theme.breakpointTo.sm} {
                margin-top: 0;
            }
        }

        .hidden {
            display: none;
        }

        .admin-actions {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    }

    .success-icon {
        color: ${(props) => props.theme.palette.secondaryA3};
    }

    .close-icon {
        position: absolute;
        right: -40px;
        top: 5px;

        ${(props) => props.theme.breakpointTo.sm} {
            right: 0;
        }
    }

    .spinner-container {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        min-height: 520px;
    }

    .liveness-title {
        position: absolute;
        top: 16px;
        z-index: 1000;
        font-size: 22px;
    }
`;

export const WebCamContainer = styled.div`
    transition: all 0.3s;
    overflow: hidden;
    position: relative;
    width: 640px;
    max-width: 640px;
    height: 640px;
    border-radius: 32px;
    border: 4px solid ${(props) => props.theme.palette.primaryA7};
    opacity: 0;

    ${(props) => {
        if (props.theme.isLandscape) {
            return {
                maxWidth: 'none',
                width: 'auto',
            };
        }

        return undefined;
    }}

    ${(props) => props.theme.breakpointTo.sm} {
        width: 100%;
        border: none;
        height: 100%;
        max-height: calc(100dvh - 32px);
        top: 0;
    }

    &.mask-ready {
        opacity: 1;
    }

    video {
        visibility: hidden;
        border-radius: 32px;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        margin-left: -50%;
        object-fit: cover;
        object-position: center;

        ${(props) => props.theme.breakpointTo.sm} {
            border-radius: 0;
            height: 100%;
            width: 100%;
            // object-fit: fill;
            left: 0;
            margin-left: 0;
            object-position: initial;
        }

        ${(props) => {
            if (props.theme.isLandscape) {
                return {
                    width: 'auto',
                    margin: 'auto',
                    right: 0,
                };
            }

            return undefined;
        }}
    }

    .wrapper {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 10;

        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(000, 000, 000, 0.5);

        @keyframes animate {
            0% {
                opacity: 0;
                transform: rotate(45deg) translate(-20px, -20px);
            }
            50% {
                opacity: 1;
            }
            100% {
                opacity: 0;
                transform: rotate(45deg) translate(20px, 20px);
            }
        }
    }
`;
